export default {"src":"/_next/static/media/Netherlands-HR.fc68d5f3.svg","height":48,"width":114,"blurWidth":0,"blurHeight":0};